import { useDashboardContext } from '@/contexts/DashboardContext';
import { useUserContext } from '@/contexts/UserContext';
import { Timestamp } from 'firebase/firestore';
import Lottie from 'lottie-react';
import React, { useEffect, useMemo, useState } from 'react';

interface StillAnalyzingAgentChatInputWrapperProps {
  children: React.ReactNode;
}

export function StillAnalyzingAgentChatInputWrapper({
  children,
}: StillAnalyzingAgentChatInputWrapperProps) {
  const { selectedAccount } = useUserContext();
  const { accountBrand } = useDashboardContext();
  const [starsAnimation, setStarsAnimation] = useState<any>(null);

  const youngAccount = useMemo(() => {
    if (!selectedAccount) return false;
    const createdAt: Timestamp = selectedAccount?.data().createdAt;
    return createdAt.toDate().getTime() + 5 * 60 * 1000 >= Date.now();
  }, [selectedAccount]);

  useEffect(() => {
    if (!accountBrand) return;
    if (accountBrand.brandGuidelines) return;
    if (!youngAccount) return;

    import('../../assets/lotties/star-magic.json').then((module) =>
      setStarsAnimation(module.default),
    );
  }, [accountBrand, youngAccount]);

  if (!accountBrand || accountBrand.brandGuidelines || !youngAccount) {
    return <>{children}</>;
  }

  return (
    <div className="relative">
      <div className="opacity-60 blur-[2px]">{children}</div>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="flex items-center justify-center gap-3 rounded-xl border border-white/80 bg-linear-to-b from-white/64 to-white/72 px-4 py-2 shadow-[3px_3px_10px_0_rgba(88,71,206,0.06)] backdrop-blur-[5px]">
          {/* Placeholder for animated logo */}
          {starsAnimation ? (
            <Lottie
              animationData={starsAnimation}
              loop={true}
              className="size-9"
            />
          ) : (
            <div className="size-9" />
          )}
          <p className="shrink-0 text-left text-xl font-medium text-[#141c25]">
            AI Agent is analyzing your brand (2-3 min)
          </p>
        </div>
      </div>
    </div>
  );
}
